export { AllocationSlider } from './AllocationSlider';
